import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { isInMentionsIndicatorExperimentCohort } from '@atlassian/jira-mentions-indicator';

export const Mentions = () => {
	const renderEmptyMentions = isInMentionsIndicatorExperimentCohort();
	return renderEmptyMentions ? <Box xcss={mentionsIndicatorStyles} /> : null;
};

const mentionsIndicatorStyles = xcss({
	width: token('space.300', '1.5rem'),
});
